module.exports = __webpack_public_path__ + "img/20190605160640813.6ce85179.png";